import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Zap } from 'lucide-react';
export function HowToUse() {
  return <section className="py-20 bg-cream-50" data-id="element-71">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl text-center" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-73">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-navy-900 mb-12" data-id="element-74">
            How to use it (without perfectionism)
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-75">
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-76">
              <div className="h-12 w-12 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6 text-teal-600" data-id="element-77">
                <Clock className="h-6 w-6" data-id="element-78" />
              </div>
              <h3 className="font-bold text-xl text-navy-900 mb-2" data-id="element-79">
                The Steady Way
              </h3>
              <p className="text-gray-600" data-id="element-80">10 minutes a day for 14 days.</p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-81">
              <div className="h-12 w-12 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6 text-orange-600" data-id="element-82">
                <Zap className="h-6 w-6" data-id="element-83" />
              </div>
              <h3 className="font-bold text-xl text-navy-900 mb-2" data-id="element-84">
                Emergency Mode
              </h3>
              <p className="text-gray-600" data-id="element-85">
                10 minutes right now — just choose the one map you need today.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}